import { classNames } from "primereact/utils";

import { useListToolbarContext } from "../list-toolbar.context";
import styles from "../list-toolbar.module.scss";
import type { ListToolbarFiltersProps } from "../types-list-toolbar";

export function ListToolbarFilters({ children, className, ...rest }: ListToolbarFiltersProps) {
  const { classNames: parts, partTestId } = useListToolbarContext();

  return (
    <div
      className={classNames(styles.filters, parts.filters, className)}
      data-testid={partTestId("filtros")}
      {...rest}
    >
      {children}
    </div>
  );
}
ListToolbarFilters.displayName = "ListToolbar.Filters";
